exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Rating-default-3YoCM{margin:5px 0;background:#fbfbfb}.Rating-score-3A4di{position:relative;float:left;margin:-5px 0 -5px 15px;padding:10px 15px;background:#00e5ce;text-align:center;color:#fff}.Rating-score-3A4di strong{display:block;height:36px;width:30px;line-height:36px;font-weight:400;font-size:20px}.Rating-score-3A4di small{position:absolute;display:block;bottom:0;left:0;right:0;font-size:14px}.Rating-body-Ly1kv{overflow:hidden;padding:5px;text-align:center}", ""]);

// exports
exports.locals = {
	"default": "Rating-default-3YoCM",
	"score": "Rating-score-3A4di",
	"body": "Rating-body-Ly1kv"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[name]-[local]-[hash:base64:5]!./~/autoprefixer-loader!./~/less-loader!./lib/core/components/Rating.less
// module id = 1656
// module chunks = 0